import * as Crypto from 'expo-crypto';
import { PasswordClientHashed } from "../data-types/SecurityDataTypes";

export const hashPassword_client = async (password: string, salt: string): Promise<PasswordClientHashed> => {
    const passwordSalted = password + salt;
    const passwordHashed = await Crypto.digestStringAsync(Crypto.CryptoDigestAlgorithm.SHA256, passwordSalted);
    return passwordHashed as PasswordClientHashed;
};